import { useMutation, useQuery } from "@apollo/client";
import { Form as AntForm } from "antd";
import { motion } from "framer-motion";
import React from "react";
import { useHistory } from "react-router-dom";
import countryList from "react-select-country-list";
import {
  componentTransition,
  componentTransitionProp,
} from "../../animation/index";
import {
  GET_AUTH_USER,
  UPDATE_DEFAULT_DESTINATION,
} from "../../app/apollo/index";
import { DropDown } from "../../globalComponents/DropDown";
import { LoggerButton } from "../../globalComponents/Index";
import withAuthentication from "../../HOC/withAuth";
import { NotificationAlert } from "../../utils/NotificationAlert";
import { Container } from "./style";
const Destination: React.FC = () => {
  const history = useHistory();
  const [value, setValue] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [updateDefaultDestination] = useMutation(UPDATE_DEFAULT_DESTINATION);

  const { data, loading: queryLoading, error } = useQuery(GET_AUTH_USER);
  if (error) {
    console.log(error);
    // NotificationAlert("error", "Error Encountered", "Kindly Refresh page");
  }

  const onFinish = async (values: any) => {
    setLoading(true);
    try {
      const response = await updateDefaultDestination({
        variables: {
          country: values.destination,
        },
      });
      if (response) {
        setLoading(false);
        if (response?.data?.updateDefaultDestination?.success) {
          history.replace("/home");
        } else {
          NotificationAlert(
            "error",
            "Error",
            response?.data?.updateDefaultDestination?.msg
          );
        }
        console.log(response);
      }
    } catch (e) {
      console.log(e.message);
      setLoading(false);

      NotificationAlert("error", "Error", "Try Again Later");
    }
  };
  const onFinishFailed = (errorInfo: any) => {
    console.log(errorInfo);
  };
  const options = React.useMemo(() => countryList().getData(), []);
  const changeHandler = (value: any) => {
    setValue(value);
  };
  console.log(data?.getAuthUser);
  console.log(error);
  return (
    <Container>
      {queryLoading ? (
        <h3>Loading...</h3>
      ) : (
        <motion.div
          variants={componentTransition}
          initial="initial"
          animate="in"
          exit="out"
          transition={componentTransitionProp}
        >
          <h3>
            Welcome <span>{data?.getAuthUser?.firstname} </span>
            <span>{data?.getAuthUser?.lastname}</span>
          </h3>
          <h2>Where would you like to know more about?</h2>
          <AntForm
            layout="vertical"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
          >
            <AntForm.Item name="destination">
              <DropDown
                required={true}
                placeholder="Select a Country"
                values={options}
                onChange={changeHandler}
              />
            </AntForm.Item>
            <br />
            <LoggerButton
              style={{ boxShadow: "none" }}
              htmlType="submit"
              loading={loading}
              text="Enter"
            />
          </AntForm>
        </motion.div>
      )}
    </Container>
  );
};

export default withAuthentication(Destination);
